"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const load_changed_shifts_count_1 = __importDefault(require("@app/ac/load-changed-shifts-count"));
const load_employee_detail_1 = __importDefault(require("@app/ac/load-employee-detail"));
const load_employees_1 = __importDefault(require("@app/ac/load-employees"));
const load_external_employees_1 = __importDefault(require("@app/ac/load-external-employees"));
const load_positions_1 = __importDefault(require("@app/ac/load-positions"));
const load_role_stats_multi_1 = __importDefault(require("@app/ac/load-role-stats-multi"));
const load_workspace_detail_1 = __importDefault(require("@app/ac/load-workspace-detail"));
const set_calendar_1 = __importDefault(require("@app/ac/set-calendar"));
const set_calendar_multi_select_1 = __importDefault(require("@app/ac/set-calendar-multi-select"));
const manager_assistant_1 = require("@app/reducer/manager-assistant");
const update_warnings_1 = __importDefault(require("@app/ac/update-warnings"));
const set_availabilities_1 = __importDefault(require("@app/action/set-availabilities"));
const set_employees_1 = __importDefault(require("@app/action/set-employees"));
const set_notifications_1 = __importDefault(require("@app/action/set-notifications"));
const set_offers_1 = __importDefault(require("@app/action/set-offers"));
const set_positions_1 = __importDefault(require("@app/action/set-positions"));
const set_shifts_1 = __importDefault(require("@app/action/set-shifts"));
const set_time_offs_1 = __importDefault(require("@app/action/set-time-offs"));
const set_workspaces_1 = __importDefault(require("@app/action/set-workspaces"));
const withPlugin_1 = require("@core/hoc/withPlugin");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const mapStateToProps = ({ auth, workspaceId, organizationId, workspaces, me, }) => {
    return {
        auth,
        workspaceId,
        organizationId,
        workspaces,
        me,
    };
};
const mapDispatchToProps = (dispatch) => {
    return (0, redux_1.bindActionCreators)({
        loadChangedShiftsCount: load_changed_shifts_count_1.default,
        loadEmployees: load_employees_1.default,
        loadEmployeeDetail: load_employee_detail_1.default,
        loadExternalEmployees: load_external_employees_1.default,
        loadPositions: load_positions_1.default,
        loadWorkspaceDetail: load_workspace_detail_1.default,
        loadRoleStatsMulti: load_role_stats_multi_1.default,
        setCalendarMultiSelect: set_calendar_multi_select_1.default,
        setCalendar: set_calendar_1.default,
        openPlanning: manager_assistant_1.openedManagerAssistantPlanning,
        setShifts: set_shifts_1.default,
        setTimeOffs: set_time_offs_1.default,
        setAvailabilities: set_availabilities_1.default,
        setOffers: set_offers_1.default,
        setEmployees: set_employees_1.default,
        setPositions: set_positions_1.default,
        setWorkspaces: set_workspaces_1.default,
        setNotifications: set_notifications_1.default,
        updateWarnings: update_warnings_1.default,
    }, dispatch);
};
exports.default = (component) => {
    return (0, redux_1.compose)(withPlugin_1.withPlugin, (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(component);
};
